export default {
    upload: 'Μεταφόρτωση αρχείου',
    fileName: 'Όνομα αρχείου',
    size: 'Μέγεθος',
    noFiles: 'Δεν υπάρχουν αρχεία ακόμα',
    noFilesText: 'Τα αρχεία που ανεβάζεις για αυτόν τον πελάτη θα εμφανίζονται εδώ.',
    noResults: 'Δεν βρέθηκαν αρχεία',
    space: 'Χωρητικότητα δίσκου λογαριασμού',
    app: 'Mobile app',
    share: 'Κοινοποίηση στην εφαρμογή του πελάτη',
    sharedSuccess: 'Το αρχείο κοινοποιήθηκε στην εφαρμογή του πελάτη',
    unsharedSuccess: 'Η κοινοποίηση του αρχείου σταμάτησε',
    fromClient: 'Στάλθηκε από τον πελάτη μέσω της εφαρμογής',
    clientUploads: 'Αποστολές πελάτη',
    clientUploadsHint: 'Ο πελάτης μπορεί να σου στέλνει φωτογραφίες και PDF από την εφαρμογή',
    clientUploadsOffGlobally: 'Είναι απενεργοποιημένες για όλους τους πελάτες από τις ρυθμίσεις σου.',
    openSettings: 'Άνοιγμα ρυθμίσεων',
    clientUploadsOn: 'Ο πελάτης μπορεί πλέον να σου στέλνει αρχεία',
    clientUploadsOff: 'Ο πελάτης δεν μπορεί πλέον να σου στέλνει αρχεία',
    fileTooBig: 'Το αρχείο ξεπερνά το μέγιστο μέγεθος των 10MB',
    dropzone: 'Σύρε εδώ ένα αρχείο ή πάτα πάνω στο πλαίσιο (μέγιστο μέγεθος 10MB)'
}